/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiMacroprojectsQueryResponse,
  GetApiMacroprojectsQueryParams,
} from '../models/GetApiMacroprojects.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiMacroprojectsQueryResponseSchema } from '../zod/getApiMacroprojectsSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiMacroprojectsQueryKey = (
  params: GetApiMacroprojectsQueryParams,
) => [{ url: '/api/macroProjects' }, ...(params ? [params] : [])] as const;

export type GetApiMacroprojectsQueryKey = ReturnType<
  typeof getApiMacroprojectsQueryKey
>;

/**
 * {@link /api/macroProjects}
 */
export async function getApiMacroprojects(
  params: GetApiMacroprojectsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiMacroprojectsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/macroProjects`,
    params,
    ...requestConfig,
  });
  return getApiMacroprojectsQueryResponseSchema.parse(res.data);
}

export function getApiMacroprojectsQueryOptions(
  params: GetApiMacroprojectsQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiMacroprojectsQueryKey(params);
  return queryOptions<
    GetApiMacroprojectsQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiMacroprojectsQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiMacroprojects(params, config);
    },
  });
}

/**
 * {@link /api/macroProjects}
 */
export function useGetApiMacroprojects<
  TData = GetApiMacroprojectsQueryResponse,
  TQueryData = GetApiMacroprojectsQueryResponse,
  TQueryKey extends QueryKey = GetApiMacroprojectsQueryKey,
>(
  params: GetApiMacroprojectsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiMacroprojectsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey =
    queryOptions?.queryKey ?? getApiMacroprojectsQueryKey(params);

  const query = useQuery(
    {
      ...getApiMacroprojectsQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
